import catalogModule from '../catalogModule';

function constantsService(languageResource) {
  'ngInject';

  const ls = languageResource;
  return {
    genreOrText(genre1, genre2) {
      return ls.get('Label.BreadCrumb.GenreOrText', { genreName1: genre1, genreName2: genre2 });
    },
    genreTextSelected(genreCount) {
      return ls.get('Label.BreadCrumb.GenreSelectedText', { genreCount });
    }
  };
}

catalogModule.factory('constantsService', constantsService);

export default constantsService;
